import React from 'react';
import Layout from '../components/Layout';
import { SecondaryButton } from '../audi-ui-components/Button';
import queryString from 'query-string';
import {
    UI_AUDI
} from '../constants';

class Maintenance extends React.Component {
    render() {
        const query = queryString.parse(this.props.location.search);
        return (
            <Layout ui={query.ui || UI_AUDI} embedded={query.embedded}>
                <div className="audi-forms__hero">
                    <img src={`${process.env.PUBLIC_PATH}img/AUDI0120_AA4_A_191001_1160x386_R1.jpg`} alt="" style={{width: '100%'}} />
                </div>

                <main className="audi-forms__page not-found">
                    <h1 className="aui-headline-3 mb-3">Maintenance</h1>
                    <p className="aui-headline-5 mb-5">This page is currently undergoing maintenance. Please check back soon.</p>
                    <SecondaryButton label="Audi Australia" href="https://www.audi.com.au" />
                    {` `}
                    <SecondaryButton label="Explore models" href="https://www.audi.com.au/au/web/en/model-range.html" />
                </main>
            </Layout>
        );
    }
}

export default Maintenance;
